type MixedArray = (string | number)[];
const compareIdArrays = (arr1?: MixedArray, arr2?: MixedArray): boolean => {
  if (!arr1 || !arr2) return false;
  if (arr1.length !== arr2.length) return false;
  const normalize = (arr: MixedArray): string[] => arr.map(value => value.toString()).sort();
  return JSON.stringify(normalize(arr1)) === JSON.stringify(normalize(arr2));
};

export default compareIdArrays;
